@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="titulo_texto">Vendedores</div>
    </div>
    <div class="pt-3 pr-4 pb-4 pl-4">
      <!-- Filtro -->
      <form [formGroup]="formFiltro" (ngSubmit)="filtrar()">
        <div class="form-row">
          <!-- Nome -->
          <div class="form-group col-sm-9">
            <label class="text-secondary"><b>Nome:</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_nome" formControlName="nome" />
            <div class="form-check mt-2">
              <input class="form-check-input" type="checkbox" id="vendedores-com-versao" formControlName="somenteComVersao" />
              <label class="form-check-label" for="vendedores-com-versao">Somente com versão preenchida</label>
            </div>
          </div>
          <div class="col-sm-3">
            <button class="btn btn-secondary btn_filtro" type="submit">Filtrar</button>
            <button class="btn btn-success btn_filtro" type="button" (click)="exportarExcel()" [disabled]="vendedores.length === 0">Exportar</button>
            @if (flag_gerencia_permissoes) {
              <button class="btn btn-info btn_filtro" type="button" (click)="abrirResumoLicencas(resumoLicencasModal)">Resumo das Licenças</button>
            }
            @if (filtrado) {
              <button class="btn btn-secondary btn_filtro" type="button" (click)="removerFiltros()">Cancelar</button>
            }
          </div>
        </div>
      </form>
      <hr class="mt-2 mb-2" />
      <div class="d-flex flex-wrap align-content-start justify-content-start">
        <!-- Qtde Vendedores -->
        <div class="quadros_numeros_lg p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-users quadros_numeros_icones"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ vendedores.length }}<br />Qtde Vendedores
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <!-- Dados -->
      <div class="table-responsive">
        <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th></th>
                @if (is_master || is_diretor) {
                  <th class="tabela_borda"></th>
                }
                <th class="tabela_borda">Nome</th>
                <th class="tabela_borda">Equipe</th>
                <th class="tabela_borda text-center">Ativo</th>
                @if (flag_gerencia_permissoes) {
                  <th class="tabela_borda text-center">Licença Ativa</th>
                }
                <th class="tabela_borda">Versão App</th>
                <th class="tabela_borda" [attr.aria-sort]="ordemUltimoLogin === 'desc' ? 'descending' : ordemUltimoLogin === 'asc' ? 'ascending' : 'none'">
                  <button type="button" class="ordenar-login" (click)="ordenarPorUltimoLogin()" [title]="ordemUltimoLogin === 'desc' ? 'Ordenar do login mais antigo para o mais recente' : 'Ordenar do login mais recente para o mais antigo'">
                    Dt Último Login <i class="fa" [ngClass]="ordemUltimoLogin === 'desc' ? 'fa-sort-desc' : ordemUltimoLogin === 'asc' ? 'fa-sort-asc' : 'fa-sort'" aria-hidden="true"></i>
                  </button>
                </th>
                <th class="tabela_borda text-center">Atual Preco-Promo</th>
                <th class="tabela_borda text-center">Tipo Usuário</th>
              </tr>
            </thead>
            <tbody>
              <tr *cdkVirtualFor="let vendedor of vendedores; templateCacheSize: 0;">
                <td class="text-center tabela_acao">
                  <i class="fa fa-pencil btn_tabela_acao" placement="right" ngbTooltip="Alterar" (click)="alterarVendedor(vendedor.id)"></i>
                </td>
                @if (is_master || is_diretor) {
                  <td class="text-center tabela_acao tabela_borda">
                    <i class="fa fa-refresh btn_tabela_acao" placement="right" ngbTooltip="Resetar Senha" (click)="resetarSenha(vendedor.id)"></i>
                  </td>
                }
                <td class="tabela_borda">{{ vendedor.fullname }}</td>
                <td class="tabela_borda">{{ vendedor.nome_equipe }}</td>
                <td class="text-center tabela_borda">
                  <span class="tag-status" [ngClass]="vendedor.is_active ? 'tag-status-ativo' : 'tag-status-inativo'">
                    {{ vendedor.is_active ? 'SIM' : 'NÃO' }}
                  </span>
                </td>
                @if (flag_gerencia_permissoes) {
                  <td class="text-center tabela_borda">
                    <span class="tag-status" [ngClass]="vendedor.flag_login_autorizado ? 'tag-status-ativo' : 'tag-status-inativo'">
                      {{ vendedor.flag_login_autorizado ? 'SIM' : 'NÃO' }}
                    </span>
                  </td>
                }
                <td class="tabela_borda">{{ vendedor.versao_app || '-' }}</td>
                <td class="tabela_borda">{{ vendedor.versao_app_ult_login ? (vendedor.versao_app_ult_login | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
                <td class="text-center tabela_borda">
                  @if (getAtualizacaoPrecoPromo(vendedor); as atualizacao) {
                    <span class="tag-status" [ngClass]="atualizacao === 'SIM' ? 'tag-status-ativo' : 'tag-status-inativo'">
                      {{ atualizacao }}
                    </span>
                  }
                </td>
                <td class="text-center tabela_borda">
                  <span class="tag-tipo-usuario" [ngClass]="getTipoUsuarioClass(vendedor)">
                    {{ getTipoUsuario(vendedor) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  </div>
}

<!-- Modal (Resumo das Licenças) -->

<ng-template #resumoLicencasModal let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-resumo-licencas"><b>Resumo das Licenças</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    @if (carregandoResumoLicencas) {
      <div class="text-center text-muted p-4">Carregando...</div>
    }

    @if (!carregandoResumoLicencas && resumoLicencas != null) {
      <div class="resumo_licencas_total">
        <div class="resumo_licencas_total_bloco">
          <i class="fa fa-id-badge"></i>
          <div>
            <div class="resumo_licencas_total_numero">{{ resumoLicencas.totalAtivos }}</div>
            <div class="resumo_licencas_total_label">Usuários Ativos (Licenças)</div>
          </div>
        </div>
        <div class="resumo_licencas_total_bloco resumo_licencas_total_bloco_valor">
          <i class="fa fa-money"></i>
          <div>
            <div class="resumo_licencas_total_numero">{{ resumoLicencas.valorMensalTotal | currency: 'BRL' }}</div>
            <div class="resumo_licencas_total_label">Total Mensal</div>
          </div>
        </div>
      </div>

      <div class="resumo_licencas_lista">
        @for (tipo of resumoLicencas.tipos; track tipo.tipo) {
          <div class="resumo_licencas_item">
            <button
              type="button"
              class="resumo_licencas_row"
              [class.resumo_licencas_row_aberto]="tipoLicencaExpandido == tipo.tipo"
              [disabled]="tipo.quantidade == 0"
              (click)="alternarTipoLicencaExpandido(tipo.tipo)">
              <span class="resumo_licencas_dot" [ngClass]="getClasseTipoLicenca(tipo.tipo)"></span>
              <span class="resumo_licencas_nome">{{ tipo.tipo }}</span>
              @if (tipo.valorTotalTipo > 0) {
                <span class="resumo_licencas_valor_tipo">{{ tipo.valorTotalTipo | currency: 'BRL' }}</span>
              }
              <span class="resumo_licencas_qtde">{{ tipo.quantidade }}</span>
              @if (tipo.quantidade > 0) {
                <i class="fa resumo_licencas_chevron" [ngClass]="tipoLicencaExpandido == tipo.tipo ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              }
            </button>

            @if (tipoLicencaExpandido == tipo.tipo) {
              <div class="resumo_licencas_detalhe">
                <table class="resumo_licencas_tabela">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Usuário</th>
                      <th class="text-right">Valor</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (usuario of tipo.usuarios; track usuario) {
                      <tr>
                        <td>{{ usuario.fullname }}</td>
                        <td>{{ usuario.username }}</td>
                        <td class="text-right">{{ usuario.valor != null ? (usuario.valor | currency: 'BRL') : '—' }}</td>
                        <td>{{ usuario.descricao || '—' }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
        }
      </div>

      <div class="resumo_licencas_rodape">
        <div class="resumo_licencas_rodape_linha">
          <span>Total Mensal Usuários</span>
          <b>{{ resumoLicencas.valorMensalUsuarios | currency: 'BRL' }}</b>
        </div>

        <div class="resumo_licencas_lista">
          <div class="resumo_licencas_item">
            <button
              type="button"
              class="resumo_licencas_row"
              [class.resumo_licencas_row_aberto]="outrasCobrancasExpandido"
              [disabled]="resumoLicencas.outrasCobrancas.length == 0"
              (click)="alternarOutrasCobrancas()">
              <span class="resumo_licencas_nome">Total Mensal Outras Cobranças</span>
              <span class="resumo_licencas_valor_total">{{ resumoLicencas.valorMensalOutrasCobrancas | currency: 'BRL' }}</span>
              @if (resumoLicencas.outrasCobrancas.length > 0) {
                <i class="fa resumo_licencas_chevron" [ngClass]="outrasCobrancasExpandido ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              }
            </button>

            @if (outrasCobrancasExpandido) {
              <div class="resumo_licencas_detalhe">
                <table class="resumo_licencas_tabela">
                  <thead>
                    <tr>
                      <th>Descrição</th>
                      <th class="text-right">Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (cobranca of resumoLicencas.outrasCobrancas; track cobranca) {
                      <tr>
                        <td>{{ cobranca.descricao }}</td>
                        <td class="text-right">{{ cobranca.valor | currency: 'BRL' }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>
